import React from 'react';
import { AppUtils } from '@gscope-mfe/app-bridge';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import classes from './StrideMarket.module.css';
import { useTranslation } from 'react-i18next';
const { Button } = MaterialUiCore;
const StrideMarket = ({ marketTab, origin, setShowMarket, selectedMarket, setSelectedMarket }) => {
    const refMarketOverflow = React.useRef();
    const marketButtons = React.useRef();
    const { permission, currentMarket, setCurrentSelectedMarket } = AppUtils.get();
    const { t } = useTranslation('commonLang');
    const setMarket = () => {
        setCurrentSelectedMarket(selectedMarket);
    };
    const resetMarket = () => {
        setSelectedMarket(currentMarket);
        setShowMarket(false);
    };
    const positionTheMarket = () => {
        const refeleTop = marketTab.current.getBoundingClientRect().top;
        const vwHeight = window.innerHeight;
        let eleBtm = window.innerHeight - marketTab.current.getBoundingClientRect().bottom;
        if (eleBtm < 0) eleBtm = 0;
        if (origin == 'ExpandedPanel') {
            //we are gonna expand upward only
            refMarketOverflow.current.style.bottom = vwHeight - marketTab.current.getBoundingClientRect().top + 'px';
            marketButtons.current.style.bottom = vwHeight - marketTab.current.getBoundingClientRect().top + 'px';
            refMarketOverflow.current.style.left = marketTab.current.getBoundingClientRect().left + 'px';
            if (vwHeight - eleBtm > vwHeight - refeleTop) {
                //add scroll
                let val = eleBtm + marketTab.current.offsetHeight;
                refMarketOverflow.current.style.maxHeight = `calc(100vh - ${val}px)`;
            }

            refMarketOverflow.current.style.visibility = 'visible';
        } else {
            // refMarketOverflow.current.style.left=window.innerWidth-marketTab.current.getBoundingClientRect().right+"px";
            refMarketOverflow.current.style.bottom =
                window.innerHeight - marketTab.current.getBoundingClientRect().bottom + 'px';
            marketButtons.current.style.bottom =
                window.innerHeight - marketTab.current.getBoundingClientRect().bottom + 'px';
            if (vwHeight - eleBtm > vwHeight - refeleTop) {
                //add scroll
                let val = eleBtm + marketTab.current.offsetHeight;
                refMarketOverflow.current.style.maxHeight = `calc(100vh - ${val}px)`;
            }
        }
    };
    React.useEffect(() => {
        if (refMarketOverflow.current) positionTheMarket();
    }, [refMarketOverflow]);

    return (
        <div className={classes.pageDrawer}>
            <div ref={refMarketOverflow} className={classes.pageContainer} style={{ visibility: 'visible' }}>
                <div style={{ fontWeight: 'bold' }} className={classes.marketHeading}>
                    {t('markets')}
                </div>

                <div className={classes.marketContainer} data-testid="marketsList">
                    {permission.markets.sort().map((moduleO, i) => {
                        return (
                            <div
                                key={i}
                                data-testid={`market${i}`}
                                style={
                                    moduleO == selectedMarket
                                        ? { backgroundColor: '#cce3f8', border: '1px solid #0071dc;' }
                                        : {}
                                }
                                className={classes.overflownModule}
                                onClick={() => setSelectedMarket(moduleO)}
                            >
                                <span style={{ marginLeft: '16px' }}>
                                    {t(moduleO) == moduleO ? moduleO.toUpperCase() : t(moduleO)}
                                </span>
                                {moduleO == selectedMarket ? (
                                    <i className={`${classes['sct-icon']} sct-icon icon-Check_2-18`} />
                                ) : (
                                    ''
                                )}
                            </div>
                        );
                    })}
                </div>
                <div ref={marketButtons} className={classes.marketButtons}>
                    <Button data-testid="cancelMarketSel" style={{ textDecoration: 'underline' }} onClick={resetMarket}>
                        {t('cancel')}
                    </Button>
                    <Button
                        data-testid="applyMarketSel"
                        style={{ background: '#0071dc', color: 'white', borderRadius: '16px' }}
                        onClick={setMarket}
                    >
                        {t('apply')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default StrideMarket;
